import { Modal } from '@wix/design-system';
import React, { createContext, useCallback, useContext, useRef, useState } from 'react';
import { StopGeneratingConfirmationModal } from '../components/modals';
import { useSharedAltTextScreenContext } from '../context/alt-text-screen-context';
const StopGeneratingGuardContext = /*#__PURE__*/createContext(null);
export const useStopGeneratingGuard = () => {
  const context = useContext(StopGeneratingGuardContext);
  if (!context) {
    throw new Error('useStopGeneratingGuard must be used within a StopGeneratingGuardProvider.');
  }
  return context;
};
export const StopGeneratingGuardProvider = _ref => {
  let {
    children
  } = _ref;
  const {
    state,
    modals,
    translations
  } = useSharedAltTextScreenContext();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const pendingActionRef = useRef(null);
  const overrideHandler = modals == null ? void 0 : modals.onCloseWhileGenerating;
  const guard = useCallback(action => {
    if (!state.isGeneratingAi) {
      action();
      return;
    }
    if (overrideHandler) {
      overrideHandler(() => action(), () => {});
      return;
    }
    pendingActionRef.current = action;
    setIsModalOpen(true);
  }, [state.isGeneratingAi, overrideHandler]);
  const onContinue = useCallback(() => {
    setIsModalOpen(false);
    pendingActionRef.current = null;
  }, []);
  const onStop = useCallback(() => {
    setIsModalOpen(false);
    const action = pendingActionRef.current;
    pendingActionRef.current = null;
    action == null || action();
  }, []);
  return /*#__PURE__*/React.createElement(StopGeneratingGuardContext.Provider, {
    value: {
      guard
    }
  }, children, /*#__PURE__*/React.createElement(Modal, {
    isOpen: isModalOpen,
    onRequestClose: onContinue
  }, /*#__PURE__*/React.createElement(StopGeneratingConfirmationModal, {
    translations: translations.stopGeneratingModal,
    onContinue: onContinue,
    onStop: onStop
  })));
};
//# sourceMappingURL=use-stop-generating-guard.js.map